import { createContext, use } from 'react';

import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { DictionaryType } from '@/context/dictionariesContext/model/DictionaryType.model.ts';

export type DictionariesContextProps = Record<DictionaryType, SelectSearchOptionModel[]>;

export const DictionariesContextDefaultValues: DictionariesContextProps = {
  [DictionaryType.USERS]: [],
};
export const DictionariesContext = createContext<DictionariesContextProps>(
  DictionariesContextDefaultValues,
);

export const useDictionariesContext = (): DictionariesContextProps => {
  return use<DictionariesContextProps>(DictionariesContext);
};
